import * as S from "./InfoItem.style";
import { InfoItemData } from "@/components/atoms/InfoItemData";

interface InfoItemProps {
  data?: any;
}

export const InfoItem = ({ data }: InfoItemProps) => {
  return (
    <S.InfoItem>
      <S.InfoItemTitle>{data.data_name}</S.InfoItemTitle>
      <S.InfoItemList>
        {data.data.map((item: any, idx: number) => {
          return <InfoItemData data={item} key={idx} />;
        })}
      </S.InfoItemList>
    </S.InfoItem>
  );
};
